/**
 * Typed accessor for values injected by webpack DefinePlugin.
 *
 * DefinePlugin substitutes the literal `process.env.<KEY>` token at build time.
 * All other modules must import from here — never access `process.env` directly
 * in application code.
 */
export const TPS_ENV: string = process.env.TPS_ENV;
export const MSAL_CLIENT_ID: string = process.env.MSAL_CLIENT_ID;
export const MSAL_TENANT_ID: string = process.env.MSAL_TENANT_ID;
export const API_BASE_URL: string = process.env.API_BASE_URL;
